<div class="row grow crop-cycles-container">
  @for (cropCycle of cropCycles; track cropCycle; let i = $index) {
    <div [style.width.%]="cropCycleContainerWidth">
      <div
        class="row center-center justify-space-between"
        [ngClass]="(i+1) % pageSize === 0 ? 'crop-cycle-inner-container' : 'crop-cycle-inner-container-with-border'"
        (click)="goToCropCycleInsightsPage(cropCycle)"
        >
        <div class="column with-gap small">
          <div class="crop-cycle-name-label">{{ cropCycle.cropCycleName | uppercase }}</div>
          <div class="crop-cycle-site-name-label">{{ cropCycle.siteName }}</div>
          <div class="crop-cycle-period-label">{{ getCropCyclePeriodLabel(cropCycle) }}</div>
        </div>
        <div class="column">
          <i class="ri-icon rif-icon_arrow_button icon-arrow-button"></i>
        </div>
      </div>
    </div>
  }
</div>
